import { BrowserRouter, Routes, Route, Outlet, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { useEffect } from "react";

import "@/index.css";
import { AuthProvider } from "@/context/AuthContext";
import { CustomerAuthProvider } from "@/context/CustomerAuthContext";
import { ThemeProvider } from "@/context/ThemeContext";

import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Analytics from "@/components/Analytics";
import CookieConsent from "@/components/CookieConsent";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Pricing from "@/pages/Pricing";
import Portfolio from "@/pages/Portfolio";
import FAQPage from "@/pages/FAQ";
import Contact from "@/pages/Contact";
import QuoteRequest from "@/pages/QuoteRequest";
import QuoteSuccess from "@/pages/QuoteSuccess";
import ThankYou from "@/pages/ThankYou";
import NotFound from "@/pages/NotFound";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import { Privacy, Terms, Refund, Cookies } from "@/pages/Legal";
import AdminLogin from "@/pages/AdminLogin";
import AdminApp from "@/pages/AdminApp";
import PortalLogin from "@/pages/portal/PortalLogin";
import PortalSignup from "@/pages/portal/PortalSignup";
import PortalApp from "@/pages/portal/PortalApp";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function PublicLayout() {
  return (
    <>
      <Navbar />
      <main className="min-h-[60vh]"><Outlet /></main>
      <Footer />
    </>
  );
}

function AuthLayout() {
  return (
    <>
      <Navbar />
      <Outlet />
    </>
  );
}

export default function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <CustomerAuthProvider>
          <BrowserRouter>
            <ScrollToTop />
            <Analytics />
            <Routes>
              <Route element={<PublicLayout />}>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/services" element={<Services />} />
                <Route path="/pricing" element={<Pricing />} />
                <Route path="/portfolio" element={<Portfolio />} />
                <Route path="/faq" element={<FAQPage />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/blog/:slug" element={<BlogPost />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/quote" element={<QuoteRequest />} />
                <Route path="/quote-success" element={<QuoteSuccess />} />
                <Route path="/thank-you" element={<ThankYou />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/refund" element={<Refund />} />
                <Route path="/cookies" element={<Cookies />} />
                <Route path="*" element={<NotFound />} />
              </Route>

              <Route element={<AuthLayout />}>
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin/*" element={<AdminApp />} />
                <Route path="/portal/login" element={<PortalLogin />} />
                <Route path="/portal/signup" element={<PortalSignup />} />
                <Route path="/portal/*" element={<PortalApp />} />
              </Route>
            </Routes>
            <CookieConsent />
          </BrowserRouter>
          <Toaster position="top-right" richColors />
        </CustomerAuthProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}
